import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getCompanyListByUserIdApi, getUserByIdApi } from '@src/api';

const getUserDetail = createAsyncThunk(
  'users/getUserDetail',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getUserByIdApi(id);

      return response.result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

const getCompaniesPreview = createAsyncThunk(
  'users/getCompaniesPreview',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getCompanyListByUserIdApi(id);

      return response.result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export { getUserDetail, getCompaniesPreview };
